<template>
  <widget
    @closed="$emit('closed')"
    title="Salari e costi del personale"
    icon="mdi-account-group"
    :bgColor="colors.orange"
    dark
  >
    <v-row no-gutters class="pl-2">
      <v-col cols="12" sm="6" lg="6" xl="6">
        <search-bar @search="updateData"></search-bar>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" md="6" class="px-2">
        <sea-legend-wage title="Costi effettivi">
          <sea-legend-head-wage
            color="#330099"
            label="Salari e stipendi"
            :value="dati.costiEffettivi.salariStipendi.totale"
          >
          </sea-legend-head-wage>
          <v-divider></v-divider>
          <sea-legend-row-wage
            label="Stipendi lordi"
            viewData
            :value="dati.costiEffettivi.salariStipendi.stipendi"
          >
          </sea-legend-row-wage>
          <v-divider></v-divider>
          <sea-legend-row-wage
            label="Ratei mensilità agg./Grafitica"
            viewData
            :value="dati.costiEffettivi.salariStipendi.rateiMensAggGrat"
          >
          </sea-legend-row-wage>
          <v-divider></v-divider>
          <sea-legend-head-wage
            color="#F50E13"
            label="Contributi Azienda"
            :value="dati.costiEffettivi.contributiAzienda.totale"
            class="mt-1"
          >
          </sea-legend-head-wage>
          <v-divider></v-divider>
          <sea-legend-row-wage
            label="Contributi Inps"
            viewData
            :value="dati.costiEffettivi.contributiAzienda.contributiInps"
          >
          </sea-legend-row-wage>
          <v-divider></v-divider>
          <sea-legend-row-wage
            label="Contributi cassa edile"
            viewData
            :value="dati.costiEffettivi.contributiAzienda.contributiCE"
          >
          </sea-legend-row-wage>
          <v-divider></v-divider>
          <sea-legend-row-wage
            label="Altri Fondi previdenziali ed assistenziali"
            viewData
            :value="dati.costiEffettivi.contributiAzienda.altriFondi"
          >
          </sea-legend-row-wage>
          <v-divider></v-divider>
          <sea-legend-head-wage
            class="mt-1"
            color="#C8BFE7"
            label="Totale costi effettivi"
            :value="dati.costiEffettivi.totale"
          >
          </sea-legend-head-wage>
          <v-divider></v-divider>
        </sea-legend-wage>
      </v-col>
      <v-col cols="12" md="6" class="px-2">
        <vue-apex-charts
          ref="graf"
          type="bar"
          height="350"
          :options="chartOptions"
          :series="series"
        ></vue-apex-charts>
      </v-col>

      <v-col cols="12" md="6" class="px-2">
        <sea-legend-wage title="Costi presunti">
          <sea-legend-head-wage
            color="#99D9EA"
            label="Ratei"
            :value="dati.costiPresunti.ratei.totale"
          >
          </sea-legend-head-wage>
          <v-divider></v-divider>
          <sea-legend-row-wage
            label="Ratei mensilità presunti"
            viewData
            :value="dati.costiPresunti.ratei.mensAggiunt"
          >
          </sea-legend-row-wage>
          <v-divider></v-divider>
          <sea-legend-row-wage
            label="Ratei Ferie, permessi e altre motivazioni"
            viewData
            :value="dati.costiPresunti.ratei.fpa"
          >
          </sea-legend-row-wage>
          <v-divider></v-divider>
          <sea-legend-head-wage
            color="#008080"
            label="TFR"
            :value="dati.costiPresunti.tfr.totale"
            class="mt-1"
          >
          </sea-legend-head-wage>
          <v-divider></v-divider>
          <sea-legend-row-wage
            label="su stipendi lordi"
            viewData
            :value="dati.costiPresunti.tfr.stipendiLordi"
          >
          </sea-legend-row-wage>
          <v-divider></v-divider>
          <sea-legend-row-wage
            label="su ratei mensilità aggiuntive"
            viewData
            :value="dati.costiPresunti.tfr.rateiMensAggiunt"
          >
          </sea-legend-row-wage>
          <v-divider></v-divider>
          <sea-legend-row-wage
            label="su ratei Ferie, permessi e altre motivazioni"
            viewData
            :value="dati.costiPresunti.tfr.rateiFPA"
          >
          </sea-legend-row-wage>
          <v-divider></v-divider>
          <sea-legend-head-wage
            color="#F50E13"
            label="Contributi Inps Azienda"
            :value="dati.costiPresunti.contrInps.totale"
            class="mt-1"
          >
          </sea-legend-head-wage>
          <v-divider></v-divider>
          <sea-legend-row-wage
            label="su ratei mensilità aggiuntiva"
            viewData
            :value="dati.costiPresunti.contrInps.rateiMensAggiunt"
          >
          </sea-legend-row-wage>
          <v-divider></v-divider>
          <sea-legend-row-wage
            label="su ratei Ferie, permessi e altre motivazioni"
            viewData
            :value="dati.costiPresunti.contrInps.rateiFPA"
          >
          </sea-legend-row-wage>
          <v-divider></v-divider>
          <sea-legend-head-wage
            color="#FF6633"
            label="Contributi Inail Azienda"
            :value="dati.costiPresunti.contrInail.totale"
            class="mt-1"
          >
          </sea-legend-head-wage>
          <v-divider></v-divider>
          <sea-legend-row-wage
            label="su stipendi lordi"
            viewData
            :value="dati.costiPresunti.contrInail.stipendiLordi"
          >
          </sea-legend-row-wage>
          <v-divider></v-divider>
          <sea-legend-row-wage
            label="su ratei mensilità aggiuntive"
            viewData
            :value="dati.costiPresunti.contrInail.rateiMensAggiunt"
          >
          </sea-legend-row-wage>
          <v-divider></v-divider>
          <sea-legend-row-wage
            label="su ratei Ferie, permessi e altre motivazioni"
            viewData
            :value="dati.costiPresunti.contrInail.rateiFPA"
          >
          </sea-legend-row-wage>
          <v-divider></v-divider>
          <v-divider></v-divider>
          <sea-legend-head-wage
            class="mt-1"
            color="#A349A4"
            label="Totale costi presunti"
            :value="dati.costiPresunti.totale"
          >
          </sea-legend-head-wage>
        </sea-legend-wage>
      </v-col>
      <v-col cols="12" md="6" class="px-2">
        <vue-apex-charts
          ref="graf"
          type="bar"
          height="350"
          :options="chartOptionsSecond"
          :series="sections"
        ></vue-apex-charts>
      </v-col>
    </v-row>
  </widget>
</template>

<script>
import Widget from "./Widget.vue";
import SeaLegendWage from "../SeaLegendWage.vue";
import SeaLegendHeadWage from "../SeaLegendHeadWage.vue";
import SearchBar from "./SearchBar.vue";
import SeaLegendRowWage from "../SeaLegendRowWage.vue";
import VueApexCharts from "vue-apexcharts";
import mixin from "@/mixin";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "salari-costi-personale",
  mixins: [mixin],
  components: {
    VueApexCharts,
    SeaLegendWage,
    SeaLegendHeadWage,
    SeaLegendRowWage,
    Widget,
    SearchBar,
  },
  mounted() {
    this.fetchData();
  },
  data() {
    return {
      da: null,
      a: null,
      chartOptions: {
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        plotOptions: {
          bar: {
            horizontal: true,
            borderRadius: 0,
          },
        },
        xaxis: {
          categories: ["", "", ""],
          labels: {
            show: true,
            formatter: (val) =>
              new Intl.NumberFormat("it-IT", {
                style: "currency",
                currency: "EUR",
                minimumFractionDigits: 0,
              }).format(val),
          },
        },
        yaxis: {
          labels: {
            show: false,
          },
        },
        legend: {
          show: false,
        },
        fill: {
          opacity: 1,
          colors: ["#330099", "#F50E13", "#C8BFE7"],
        },
      },
      chartOptionsSecond: {
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        plotOptions: {
          bar: {
            horizontal: true,
            borderRadius: 0,
          },
        },
        xaxis: {
          type: "category",
          categories: ["", "", "", "", ""],
          labels: {
            show: true,
            formatter: (val) =>
              new Intl.NumberFormat("it-IT", {
                style: "currency",
                currency: "EUR",
                minimumFractionDigits: 0,
              }).format(val),
          },
        },
        yaxis: {
          labels: {
            show: false,
          },
        },
        legend: {
          show: false,
        },
        fill: {
          opacity: 1,
          colors: ["#99D9EA", "#008080", "#F50E13", "#FF6633", "#A349A4"],
        },
      },
    };
  },
  methods: {
    ...mapActions({
      fetchData: "widget/fetchExpensesData",
    }),
    formatYM(date) {
      if (!date) return null;
      const [year, month] = date.split("-");
      return `${year}${month}`;
    },
    updateData(da, a) {
      let dataDa = this.formatYM(da);
      let dataA = this.formatYM(a);
      this.fetchData({ da: dataDa, a: dataA });
    },

    updateOptions(options) {
      this.$refs.graf.updateOptions(options);
    },
  },
  computed: {
    ...mapGetters({
      dati: "widget/expenses",
    }),

    series() {
      return [
        {
          name: "Salari e stipendi",
          data: [this.dati.costiEffettivi.salariStipendi.totale, 0, 0],
        },
        {
          name: "Contributi Azienda",
          data: [0, this.dati.costiEffettivi.contributiAzienda.totale, 0],
        },
        {
          name: "Totale costi effettivi",
          data: [0, 0, this.dati.costiEffettivi.totale],
        },
      ];
    },
    sections() {
      return [
        {
          name: "Ratei",
          data: [this.dati.costiPresunti.ratei.totale, 0, 0, 0, 0],
        },
        {
          name: "TFR",
          data: [0, this.dati.costiPresunti.tfr.totale, 0, 0, 0],
        },
        {
          name: "Contributi INPS azienda",
          data: [0, 0, this.dati.costiPresunti.contrInps.totale, 0, 0],
        },
        {
          name: "Contributi Inail azienda",
          data: [0, 0, 0, this.dati.costiPresunti.contrInail.totale, 0],
        },
        {
          name: "Totale costi presunti",
          data: [0, 0, 0, 0, this.dati.costiPresunti.totale],
        },
      ];
    },
  },
};
</script>

<style>
</style>